import script from "./num_pad.vue?vue&type=script&setup=true&lang=js"
export * from "./num_pad.vue?vue&type=script&setup=true&lang=js"

import "./num_pad.vue?vue&type=style&index=0&id=48a58c92&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48a58c92"]])

export default __exports__